export default __webpack_public_path__ + "media/notification.586abd07.svg";